import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { LearnerProfileConceptActions } from '.';
import { RecommendationActions } from '../recommendation';

@Injectable()
export class LearnerProfileConceptEffects {
  private actions$: Actions = inject(Actions);

  upsertLearnerProfileConcepts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecommendationActions.recommendationsForContextLoaded),
      filter(({ learnerProfileConcepts }) => !!learnerProfileConcepts && learnerProfileConcepts.length > 0),
      map(
        ({ learnerProfileConcepts }) =>
          new LearnerProfileConceptActions.UpsertLearnerProfileConcepts({ learnerProfileConcepts })
      )
    )
  );

  addLearnerProfileConceptsForTocRecommendations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecommendationActions.recommendationsForContextLoaded),
      filter(({ learnerProfileConcepts, context }) => !!context.tocId && learnerProfileConcepts?.length > 0),
      map(
        ({ learnerProfileConcepts, context }) =>
          new LearnerProfileConceptActions.AddLearnerProfileConceptsForToc({
            tocId: context.tocId,
            learnerProfileConcepts,
          })
      )
    )
  );

  upsertLearnerProfileConceptsForDashboardRecommendations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RecommendationActions.recommendationsForContextLoaded),
      filter(({ learnerProfileConcepts, context }) => !context.tocId && learnerProfileConcepts?.length > 0),
      map(
        ({ learnerProfileConcepts }) =>
          new LearnerProfileConceptActions.UpsertLearnerProfileConcepts({ learnerProfileConcepts })
      )
    )
  );
}
